import React from "react"
import moment from "moment"
import SummarySection from "./SummarySection"
import DetailsSection from "./DetailsSection"

const DATE_TIME_FORMAT = "DD/MM/YYYY hh:mm A"

const groupLeaveByUser = (leaveDetails) => {
  return leaveDetails.reduce((acc, row) => {
    const name = row.userName ?? "—"
    if (!acc[name]) acc[name] = []
    acc[name].push(row)
    return acc
  }, {})
}

const ReportTable = ({ byDraftingType, total, leaveDetails = [] }) => {
  const hasReport = byDraftingType?.length > 0
  const hasLeave = leaveDetails?.length > 0
  const leaveByUser = hasLeave ? groupLeaveByUser(leaveDetails) : {}

  if (!hasReport && !hasLeave) {
    return <p className="my-5">No Data Available</p>
  }

  return (
    <React.Fragment>
      {hasReport && byDraftingType.map(section => (
        <div key={section.drafting_type} className="my-5">
          <h4 className="mb-3">DRAFTING TYPE: {section.label}</h4>
          <div className="mb-4">
            {section.summary?.length ? (
              <SummarySection summaryRows={section.summary} totalRow={section.total} />
            ) : (
              <p>No Data Available</p>
            )}
          </div>
          <div>
            {(section.detail || []).map(group => (
              <DetailsSection
                key={group.name}
                rows={group}
                filters={{ drafting_type: section.drafting_type }}
              />
            ))}
          </div>
        </div>
      ))}
      {hasLeave && (
        <div className="my-5">
          <h4 className="mb-3">Leave details</h4>
          {Object.entries(leaveByUser).map(([userName, rows]) => (
            <div key={userName} className="my-5">
              <h5 className="mb-3 font-weight-bold text-uppercase" style={{ color: "#1a365d" }}>
                {userName}
              </h5>
              <div className="table-responsive">
                <table className="table table-listing table-hover table-striped">
                  <thead>
                    <tr>
                      <th>On Leave</th>
                      <th>Leave Type</th>
                      <th>Start</th>
                      <th>End</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, idx) => (
                      <tr key={idx}>
                        <td>On Leave</td>
                        <td>{row.leaveType ? String(row.leaveType).replace(/\b\w/g, c => c.toUpperCase()) : "—"}</td>
                        <td>{row.startAt ? moment(row.startAt).format(DATE_TIME_FORMAT) : "—"}</td>
                        <td>{row.endAt ? moment(row.endAt).format(DATE_TIME_FORMAT) : "—"}</td>
                      </tr>
                    ))}
                    <tr className="font-weight-bold bg-secondary text-white">
                      <td colSpan={3}>Total leaves taken</td>
                      <td>{rows.length}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}
      {hasReport && byDraftingType.length > 1 && (
        <div className="my-5 p-3" style={{ border: "1px solid" }}>
          <h5>Overall Total</h5>
          <p className="mb-0">
            <strong>Jobs Complete:</strong> {total.jobsComplete} &nbsp;|&nbsp;
            <strong>Total Time Spent:</strong> {total.totalWorkedTime} Hrs
          </p>
        </div>
      )}
    </React.Fragment>
  )
}

export default ReportTable
